"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAttendeesEndpoints = createAttendeesEndpoints;
/**
 * Organizatörün katılımcı yüzeyleri: dizin ve TOPLU analitik.
 */
function createAttendeesEndpoints(client) {
    return {
        attendees: {
            /**
             * Katılımcı listesi (Story 7.2) — yalnızca opt-in vermiş katılımcılar döner.
             * `seniority` + `sector` ekran 6b filtreleridir: kapalı taksonomi olduğu için
             * serbest metin değil, shared enum tipiyle daraltılır.
             */
            list: (eventId, query) => client.call('/events/{eventId}/attendees', 'get', {
                path: { eventId },
                query: query,
            }),
            /** Kişi profili yan paneli (ekran 7) — yalnızca GÖRÜNÜR katılımlar. */
            sharedEvents: (eventId, userId) => client.call('/events/{eventId}/attendees/{userId}/shared-events', 'get', {
                path: { eventId, userId },
            }),
        },
        /** Organizatör analitiği (ekran 21) — TOPLU veri, kişi taşımaz. */
        analytics: {
            event: (eventId) => client.call('/events/{eventId}/analytics', 'get', { path: { eventId } }),
            /**
             * Etkinlik sonu raporu (kapsam 25.10.2026) — TOPLU sayı, kişi taşımaz.
             * PDF ucu ikili akış döndürdüğü için tipli istemcinin dışında indirilir.
             */
            report: (eventId) => client.call('/events/{eventId}/report', 'get', { path: { eventId } }),
        },
    };
}
//# sourceMappingURL=attendees.js.map